import React, { useState } from 'react';
import PropTypes from 'prop-types';

const SiteContext = React.createContext();

const SiteState = ({ children }) => {
  const [primaryNavOpen, setPrimaryNavOpen] = useState(false);

  return (
    <SiteContext.Provider
      value={{
        primaryNavOpen,
        setPrimaryNavOpen,
      }}
    >
      {children}
    </SiteContext.Provider>
  );
};

SiteState.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default SiteState;

// eslint-disable-next-line react/prop-types
export const wrapRootElement = ({ element }) => <SiteState>{element}</SiteState>;

export { SiteContext };
